import { t } from '../i18n'
import { track } from './analytics'
import { storyUrl } from './article'

/* Share a story's Instapres link (never the portal's link, spec 9.9): the
   system share sheet where there is one, else copy it. `notify` shows a toast.
   The link says it was shared from the web (analytics spec 4.1). */
export async function shareStory(story, notify, surface = null) {
  const url = `${storyUrl(story.id)}?utm_source=share&utm_medium=web`
  track('share', {
    story_id: story.id,
    surface,
    method: navigator.share ? 'web_share' : 'copy_link',
  })
  if (navigator.share) {
    try {
      await navigator.share({ title: story.title, url })
      return
    } catch (e) {
      if (e && e.name === 'AbortError') return // the user closed the sheet
    }
  }
  try {
    await navigator.clipboard.writeText(url)
    notify(t('share.copied'))
  } catch (e) {
    notify(t('share.failed'))
  }
}
